"use client";

import { useEffect } from "react";
import { usePathname } from "@/lib/cwfNavigation";
import {
  applyAmbientBgmForPath,
  syncBgmPlaybackVolume,
  unlockGameAudio,
} from "@/lib/audio/play";
import { useAudioSettings } from "@/stores/audioSettings";

/**
 * Menu BGM (`bgm_menu`) + duel BGM (`bgm_loop`) after first gesture; swaps on route change.
 */
export function useAmbientBgm(): void {
  const pathname = usePathname();

  useEffect(() => {
    return useAudioSettings.subscribe(() => {
      syncBgmPlaybackVolume();
    });
  }, []);

  useEffect(() => {
    applyAmbientBgmForPath(pathname);
  }, [pathname]);

  useEffect(() => {
    const onGesture = () => {
      unlockGameAudio();
      requestAnimationFrame(() => {
        applyAmbientBgmForPath(pathname);
      });
    };
    window.addEventListener("pointerdown", onGesture, {
      capture: true,
      passive: true,
    });
    window.addEventListener("touchstart", onGesture, {
      capture: true,
      passive: true,
    });
    return () => {
      window.removeEventListener("pointerdown", onGesture, { capture: true });
      window.removeEventListener("touchstart", onGesture, { capture: true });
    };
  }, [pathname]);
}
